import { ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// The semantic type scale (tailwind.config.ts > fontSize) must be recognised as font sizes; otherwise
// tailwind-merge reads `text-kpi` as a colour and a later `text-gray-900` silently removes it.
const twMerge = extendTailwindMerge({
  classGroups: {
    'font-size': [{ text: ['title', 'heading', 'kpi', 'body', 'label', 'caption'] }],
  },
});

export default function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
